export default `
  mutation FinalizeOnboarding($input: FinalizeOnboardingInput!) {
    finalizeOnboarding(input: $input) {
      success
      message
    }   
  }
`
